import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getEmidates,
  emidateListSuccessful,
  emidateAddSuccessful,
  isModelVisible,
} from "./emidates​Slice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getEmidate({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/emidates/", params);
    yield put(emidateListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddEmidate({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/emidates/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Emi Date Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getEmidates({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Emi Date. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(emidateAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/emidates/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Emi Date Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getEmidates({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Emi Date. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(emidateAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteEmidate({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/emidates/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Emi Date has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getEmidates({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Emi Date has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetEmidates() {
  yield takeEvery("emidates/getEmidates", getEmidate);
}
export function* watchEmidateAdd() {
  yield takeEvery("emidates/emidateAdd", AddEmidate);
}

export function* watchEmidateDelete() {
  yield takeEvery("emidates/emidateDelete", DeleteEmidate);
}

function* EmidatesSaga() {
  yield all([
    fork(watchgetEmidates),
    fork(watchEmidateAdd),
    fork(watchEmidateDelete),
  ]);
}

export default EmidatesSaga;
